import { render, staticRenderFns } from "./EditBrokerAccount.vue?vue&type=template&id=742dc775&scoped=true"
import script from "./EditBrokerAccount.vue?vue&type=script&lang=js"
export * from "./EditBrokerAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742dc775",
  null
  
)

export default component.exports